module.exports = __webpack_public_path__ + "assets/img/9.deb723a2.jpg";